import React from 'react'
import { useTranslation } from 'react-i18next'

import { BuildingEnergyRatingTypeString, ContentStateProperty, FieldProps } from '../../../../../../../@types/types'
import { ConstructionScreenValidationResult } from '../../../../../../../@types/validation-types'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'

const property = 'buildingEnergyRatingType'

export interface BuildingEnergyRatingTypeProps extends Omit<
  FieldProps<ConstructionScreenValidationResult>,
  'onChange'
> {
  onEnergyCertificateChange: (field: ContentStateProperty, value: string | boolean | undefined) => void
}

const BuildingEnergyRatingTypeField: React.FC<BuildingEnergyRatingTypeProps> = ({
  insertionData,
  onEnergyCertificateChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className='grid-item one-whole margin-top-l'>
      <label
        className='input-label padding-none'
        htmlFor='building-energy-rating-type'
        id='building-energy-rating-type-input-label'
      >
        {t('wizard.screen.construction.buildingEnergyRating', 'Building energy rating')}
      </label>
      <ChipOptionField
        id='building-energy-rating-type'
        propertyName={property}
        option={insertionData.buildingEnergyRatingType}
        options={BuildingEnergyRatingTypeString}
        translation='wizard.screen.construction.buildingEnergyRatingType.'
        labelTranslationKey=''
        enableDeselection={false}
        onChange={(value) => onEnergyCertificateChange(property, value)}
      />
    </div>
  )
}

export default BuildingEnergyRatingTypeField
